import {
  ReduxLoggingState,
  ReduxLoggingTypeEnum,
  ReduxLogsType,
} from './redux-logging-reducer'

export const ADD_REDUX_LOG = 'ADD_REDUX_LOG'
export const SET_REDUX_LOG_DATA = 'SET_REDUX_LOG_DATA'
export const SEND_REDUX_LOGS_TO_ROLLBAR = 'SEND_REDUX_LOGS_TO_ROLLBAR'
export const RESET_REDUX_LOG_DATA = 'RESET_REDUX_LOG_DATA'
export const RESET_ALL_REDUX_LOG_DATA = 'RESET_ALL_REDUX_LOG_DATA'

export const REDUX_LOGGING_ACTIONS_TYPES = [
  ADD_REDUX_LOG,
  SET_REDUX_LOG_DATA,
  SEND_REDUX_LOGS_TO_ROLLBAR,
  RESET_REDUX_LOG_DATA,
  RESET_ALL_REDUX_LOG_DATA,
] as const

export type AddReduxLog = {
  type: typeof ADD_REDUX_LOG
  payload: ReduxLogsType[0]
}

export type SetReduxLogData<ReduxLoggingType extends ReduxLoggingTypeEnum> = {
  type: typeof SET_REDUX_LOG_DATA
  payload: {
    logType: ReduxLoggingType
    data: NonNullable<ReduxLoggingState['logData'][ReduxLoggingType]>[0]
  }
}

export type SendReduxLogsToRollbar<
  ReduxLoggingType extends ReduxLoggingTypeEnum,
> = {
  type: typeof SEND_REDUX_LOGS_TO_ROLLBAR
  payload: {
    logType: ReduxLoggingType
    data: NonNullable<ReduxLoggingState['logData'][ReduxLoggingType]>[0]
  }
}

export type ResetReduxLogData<ReduxLoggingType extends ReduxLoggingTypeEnum> = {
  type: typeof RESET_REDUX_LOG_DATA
  payload: {
    logType: ReduxLoggingType
    data: NonNullable<ReduxLoggingState['logData'][ReduxLoggingType]>[0]
  }
}

export type ResetAllReduxLogData = {
  type: typeof RESET_ALL_REDUX_LOG_DATA
  payload: {
    logType: ReduxLoggingTypeEnum
  }
}

export type ReduxLoggingActionTypes<
  ReduxLoggingType extends ReduxLoggingTypeEnum,
> =
  | AddReduxLog
  | SetReduxLogData<ReduxLoggingType>
  | SendReduxLogsToRollbar<ReduxLoggingType>
  | ResetReduxLogData<ReduxLoggingType>
  | ResetAllReduxLogData
